function Privacy() {
    return (
      <div style={{ width: "100vw", height: "100vh"}}>
        <iframe width="100%" height="100%" title="privacy" src="https://docs.google.com/document/d/e/2PACX-1vQhVac28c14AtmwTWjP74DfPPuKC397ZU9kEaSfbhfJNZ_SEWt2nZtJRNtnM4AtXOyWH9dz0jHxAYSC/pub?embedded=true"></iframe>
      </div>
    );
}
  
export default Privacy;